import { EMPTY_GUID } from '@utils/guid-utils'
import type { Property } from '@/types/Property'
import type { PropertyDetailsDto } from '@/types/PropertyDto'

interface PropertySearchContext {
  municipality: string
  farmNumber: string
  propertyNumber?: string
  municipalityName?: string
}

export const mapDtoToProperties = (
  dto: PropertyDetailsDto,
  params: PropertySearchContext,
): Property[] => {
  const municipalityNumber = params.municipality || ''
  const farmNum = params.farmNumber || ''
  const propNum = params.propertyNumber ?? ''
  const dbId = dto.id !== EMPTY_GUID ? dto.id : undefined
  const hnr = {
    municipalityNumber: Number(municipalityNumber),
    farmNumber: Number(farmNum),
    holdingNumber: Number(propNum),
    leaseNumber: 0,
  }

  const hnrProperty: Property = {
    municipality: { name: params.municipalityName ?? '', number: municipalityNumber },
    farmNumber: farmNum,
    propertyNumber: undefined,
    mainNumber: `${municipalityNumber}-${farmNum}`,
    cadastralNumber: dto.cadastralNumber,
    property: `${municipalityNumber}-${farmNum}`,
    name: '',
    area: dto.area.totalArea,
    productiveArea: dto.area.productiveArea,
    shares: dto.shares ?? 0,
    bonitet: { class: 0, siteIndex: 0 },
    hnr,
    isHnr: true,
    dbId,
  }

  const searchedProperty: Property = {
    municipality: { name: params.municipalityName ?? '', number: municipalityNumber },
    farmNumber: farmNum,
    propertyNumber: propNum || '0',
    mainNumber: `${municipalityNumber}-${farmNum}-${propNum}`,
    cadastralNumber: dto.cadastralNumber,
    property: `${municipalityNumber}-${farmNum}-${propNum}`,
    name: '',
    area: dto.area.totalArea,
    productiveArea: dto.area.productiveArea,
    shares: dto.shares ?? 0,
    bonitet: { class: 0, siteIndex: 0 },
    hnr,
    isHnr: false,
    dbId,
  }

  return [hnrProperty, searchedProperty]
}
